import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ListItemText from '@material-ui/core/ListItemText';

export default class EntityLaunchpanel extends Component {
  constructor(public props) {
    super(props);

    this.state = {
      isLaunchPanelOpen: true
    }
  }

  public toggleLaunchpanel = () => {
    this.props.dispatch({
      type: Constants.PAGE_SETTINGS_PREFERENCES_UPDATE_START,
      payload: {
        preferences: {
          entityPanelState: !this.props.app?.settings?.user?.entityPanelState,
          userId: this.props.app.session.user.id,
          hideSnackbar: true
        }
      }
    })
  }

  public render() {
    return (
      <div className={"entity-launchpanel"} style={this.props.panelWithMoreButton}>
        <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          style={{ paddingBottom: this.props.panelWithMoreButton ? "0" : "8px" }}
        >
          <ListItem
            button
            onClick={this.toggleLaunchpanel}
          >
            <ListItemText primary={`${this.props.entityTitle}`} />
            {this.props.app?.settings?.user?.entityPanelState ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={this.props.app?.settings?.user?.entityPanelState} timeout="auto" unmountOnExit>
            {this.props.actionsList}
          </Collapse>
        </List>
      </div>
    );
  }
}
